import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { PropTypes } from 'prop-types'
import {styles} from './styles.css'
export class ProgressBar extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    let progressStyle = {}
    let stepNumber=this.props.StepNumber
    let noOfSteps=this.props.NoOfSteps
    if (stepNumber === 0) {
      progressStyle.width = '0%'
    }
    else {
      progressStyle.width = Math.round(((stepNumber) * 100 / noOfSteps)) + '%'
    }

    return (
      <div className="meter">
        <span id="progressbar" style={progressStyle}></span>
        Percentuale di completamento {progressStyle.width}
      </div>
    )
  }
}
ProgressBar.propTypes = {
  //widget: PropTypes.object.isRequired,
  //components: PropTypes.object.isRequired,
  styles: PropTypes.object,
  //step: PropTypes.object.isRequired,
  StepNumber:PropTypes.object,
  NoOfSteps: PropTypes.object
}


// WEBPACK FOOTER //
// ./components/progressBar/index.js